const darkTheme = {
  name: 'dark',
  token: {
    colorPrimary: '#22247B',
    colorLink: '#22247B',
  },
  components: {
    Button: {
      // Tokens principaux pour Button
      colorPrimary: '#22247B',
      colorPrimaryHover: '#2d2f9e',
      colorPrimaryActive: '#1a1b5a',
      colorPrimaryText: '#ffffff',
      colorPrimaryBg: '#22247B',
      colorPrimaryBorder: '#22247B',
      colorPrimaryBorderHover: '#2d2f9e',
      colorPrimaryBorderActive: '#1a1b5a',

      // Tokens pour les autres variantes
      colorBgContainer: '#141414',
      colorBorder: '#424242',
      colorText: '#ffffff',
      colorTextDisabled: '#ffffff40',
      colorBgContainerDisabled: '#262626',
      colorBorderDisabled: '#424242',

      // Tokens pour les tailles
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,

      // Tokens pour le padding
      paddingInline: 15,
      paddingInlineLG: 15,
      paddingInlineSM: 7,
    },
    Dropdown: {
      // Tokens principaux pour Dropdown
      colorBgElevated: '#1f1f1f',
      colorBgContainer: '#1f1f1f',
      colorBorderSecondary: '#303030',
      colorText: '#ffffff',
      colorTextDescription: '#ffffff73',

      // Tokens pour les éléments du menu
      colorItemBg: '#1f1f1f',
      colorItemBgHover: '#262626',
      colorItemBgSelected: '#111b26',
      colorItemText: '#ffffff',
      colorItemTextHover: '#ffffff',
      colorItemTextSelected: '#177ddc',

      // Tokens pour le padding et la taille
      paddingBlock: 5,
      paddingInline: 12,
      borderRadius: 6,

      // Token pour le z-index
      zIndexPopup: 1050,
    },
  },
};

export default darkTheme;
